import { emptySettingsSection, fetchSettingsFilters } from "@actions/index";
import OpeningHours from "@components/systemAdmin/OpeningHours";
import Operators from "@components/systemAdmin/Operators";
import Organisation from "@components/systemAdmin/Organisation";
import Compliance from "@components/systemAdmin/Compliance";
import SystemSettings from "@components/systemAdmin/SystemSettings";
import React from "react";
import { connect } from "react-redux";
import { Tab } from "semantic-ui-react";
import RevenueTermsProfiles from "../systemAdmin/RevenueTermsProfiles";
class SystemAdminView extends React.Component {
  state = {
    activeIndex: 0,
  };

  componentDidMount = () => {
    this.props.fetchSettingsFilters({ showOrgTree: false });
  };

  componentWillUnmount = () => {
    this.props.emptySettingsSection();
  };

  componentDidUpdate() {
    const panes = this.getPanes();
    if (panes[this.state.activeIndex].key === "Organisation") {
      this.props.fetchSettingsFilters({ showOrgTree: true });
    } else {
      this.props.fetchSettingsFilters({ showOrgTree: false });
    }
  }

  handleTabChange = (_e, { activeIndex }) => {
    const panes = this.getPanes();
    if (panes[activeIndex].key === "Organisation") {
      this.props.fetchSettingsFilters({ showOrgTree: true });
    } else {
      this.props.fetchSettingsFilters({ showOrgTree: false });
    }
    this.setState({ activeIndex });
  };

  getPanes = () => {
    const panes = [];
    const {
      optionShowSysAdminOperatorTab,
      optionShowSysAdminOrganisationTab,
      optionShowSysAdminSystemSettingsTab,
      optionShowSysAdminSiteOpeningTab,
      optionShowSysAdminComplianceTab,
      optionShowSysAdminRevenueTermsProfileTab,
    } = this.props.login;

    if (optionShowSysAdminOperatorTab) {
      panes.push({
        key: "Operators",
        menuItem: "Operators",
        pane: (
          <Tab.Pane>
            <Operators />
          </Tab.Pane>
        ),
      });
    }

    if (optionShowSysAdminOrganisationTab) {
      panes.push({
        key: "Organisation",
        menuItem: "Organisation",
        pane: (
          <Tab.Pane>
            <Organisation />
          </Tab.Pane>
        ),
      });
    }

    if (optionShowSysAdminSystemSettingsTab) {
      panes.push({
        key: "Settings",
        menuItem: "System Settings Profile",
        pane: (
          <Tab.Pane>
            <SystemSettings />
          </Tab.Pane>
        ),
      });
    }

    if (optionShowSysAdminSiteOpeningTab) {
      panes.push({
        key: "Opening Hours",
        menuItem: "Site Opening Hours Profiles",
        pane: (
          <Tab.Pane>
            <OpeningHours />
          </Tab.Pane>
        ),
      });
    }

    const hasCompliancePermission = this.props.login.menu
      .map((item) => item.code)
      .includes("COMPLIANCE_MENU");

    if (optionShowSysAdminComplianceTab && hasCompliancePermission) {
      panes.push({
        key: "Compliance",
        menuItem: "Compliance",
        pane: (
          <Tab.Pane>
            <Compliance />
          </Tab.Pane>
        ),
      });
    }

    if (optionShowSysAdminRevenueTermsProfileTab) {
      panes.push({
        key: "Revenue Terms Profile",
        menuItem: "Revenue Terms Profile",
        pane: (
          <Tab.Pane>
            <RevenueTermsProfiles />
          </Tab.Pane>
        ),
      });
    }

    return panes;
  };

  render() {
    const panes = this.getPanes();
    return (
      <div className="flex-stretch gs-flex-container-vertical mt-1 height-100 pb-1">
        <Tab
          renderActiveOnly={false}
          activeIndex={this.state.activeIndex}
          panes={panes}
          onTabChange={this.handleTabChange}
          className="flex-stretch gs-flex-container-vertical mt-1 height-100 pb-1"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    login: state.logIn,
  };
};

export default connect(mapStateToProps, {
  fetchSettingsFilters,
  emptySettingsSection,
})(SystemAdminView);
